import type { ReactNode } from "react";

/**
 * Scanner — its own top-level section (the Top-Down breadth matrix), kept
 * SEPARATE from Market Timing. Single page, so no sub-tab bar.
 */
export default function ScannerLayout({ children }: { children: ReactNode }) {
  return (
    <main className="legacy-light w-full px-6 py-2 xl:px-8 2xl:px-10">
      {children}
    </main>
  );
}
